import CheckboxField from 'components/forms/checkboxField/CheckboxField';
import { Col, Row } from 'react-bootstrap';
import { getLanguageName } from 'i18n/i18n.utils';
import { useTranslation } from 'react-i18next';
import { LanguageCode } from 'i18n/internationalization.types';
import { orderBy } from 'utils/arrayUtils';
import { LANGUAGES } from '../ManageLanguages.constants';
import { ManageLanguagesModalDescription } from '../ManageLanguagesModal.styles';

const ManageLanguagesFields = () => {
  const { i18n, t } = useTranslation();

  const sortedLanguages = orderBy(
    [...LANGUAGES],
    [
      // English is fixed at the top
      { field: (l) => (l === LanguageCode.EN ? 0 : 1), order: 'asc' },
      { field: (l) => getLanguageName(i18n.language, l), order: 'asc' },
    ],
  );

  return (
    <>
      <ManageLanguagesModalDescription>
        {t('pageAutomations.common.manageLanguagesModal.description')}
      </ManageLanguagesModalDescription>
      <Row>
        {sortedLanguages.map((language) => (
          <Col key={language} md={5}>
            <CheckboxField
              key={language}
              name={`locales.${language}`}
              disabled={language === LanguageCode.EN}
            >
              {getLanguageName(i18n.language, language)}
            </CheckboxField>
          </Col>
        ))}
      </Row>
    </>
  );
};

export default ManageLanguagesFields;
